import { render } from "./myPage.vue?vue&type=template&id=6e0d0efc"
import script from "./myPage.vue?vue&type=script&lang=js"
export * from "./myPage.vue?vue&type=script&lang=js"

import "./myPage.vue?vue&type=style&index=0&id=6e0d0efc&lang=css"

import exportComponent from "C:\\Users\\NASTYFACT\\Desktop\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__